module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-GB"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Oh Death who are you?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh you encaged black and white bird")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh you who have taken life away")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You feared by men, feared by all ")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You who said no to tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You whom darkness belongs to")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh you powerful one, you friend of nobody")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You unkind to human life, unkind to human body")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You the one that puts end to pain to cause pain")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You older than all others, than life")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh you who will die last")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You whom everyone bows down to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You who invite all to live with you")])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh death who are you?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5b426e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398406179_EPUB3.vue
// module id = 66
// module chunks = 0